import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

const DONE = ["completed", "failed"];

export function useQueueJob(jobId, { onCompleted, onFailed } = {}) {
  const handled = useRef(null);
  const q = useQuery({
    queryKey: ["queue", jobId],
    queryFn: () => get(`/queue/${jobId}`),
    enabled: !!jobId,
    refetchInterval: (query) => (DONE.includes(query.state.data?.status) ? false : 1000),
    staleTime: 0,
  });
  const data = q.data;
  useEffect(() => {
    if (!data || handled.current === `${jobId}:${data.status}`) return;
    if (data.status === "completed") { handled.current = `${jobId}:completed`; onCompleted?.(data); }
    if (data.status === "failed") { handled.current = `${jobId}:failed`; onFailed?.(data); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, jobId]);
  return data;
}
